import { render, staticRenderFns } from "./DashboardFournisseur.vue?vue&type=template&id=386d4e48&scoped=true"
import script from "./DashboardFournisseur.vue?vue&type=script&lang=js"
export * from "./DashboardFournisseur.vue?vue&type=script&lang=js"
import style0 from "./DashboardFournisseur.vue?vue&type=style&index=0&id=386d4e48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386d4e48",
  null
  
)

export default component.exports